import type { SelectInputProps } from "react-admin";
import { SelectInput, useGetList } from "react-admin";

import type { ModuleValue } from "@/types/modules";

type Props = Omit<SelectInputProps, "resource"> & {
  module: ModuleValue;
  sort?: { field: string; order: "ASC" | "DESC" };
};

const STALE_TIME = 60_000;

export const ReferenceSelectInput = ({ module, sort, ...rest }: Props) => {
  const { isPending, data } = useGetList(
    module,
    {
      sort: sort ?? { field: "id", order: "ASC" },
      filter: {
        pagination: false,
      },
    },
    {
      staleTime: STALE_TIME,
    },
  );

  return <SelectInput {...rest} isPending={isPending} choices={data ?? []} />;
};
